module.exports = __webpack_public_path__ + "static/media/phone.d786499.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Waving/phone.mp4
// module id = JlRt
// module chunks = 1